import { render, staticRenderFns } from "./BusinessStatusReport.vue?vue&type=template&id=95e31638&scoped=true"
import script from "./BusinessStatusReport.vue?vue&type=script&lang=js"
export * from "./BusinessStatusReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95e31638",
  null
  
)

export default component.exports